"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_observable_1 = require("redux-observable");
const typescript_fsa_1 = __importDefault(require("typescript-fsa"));
const reducerWithImmer_1 = require("./reducerWithImmer");
exports.initialState = {
    collaborators: []
};
const actionCreator = typescript_fsa_1.default('gamebook');
exports.actions = {
    setCollaborators: actionCreator('SET_COLLABORATORS')
};
const user = reducerWithImmer_1.reducerWithImmer(exports.initialState)
    .case(exports.actions.setCollaborators, (draft, payload) => {
    draft.collaborators = payload;
})
    .toReducer();
exports.default = user;
exports.reducers = {
    user
};
exports.epic = redux_observable_1.combineEpics();
